import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { VacantPositionService } from '../../../services';
import { catchError, defaultIfEmpty, map } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { VacantPositionModel } from '../../../models/vacant-position.model';
import { nrError } from '../../../helpers/newrelic.helper';

@Injectable()
export class VacantPositionResolver implements Resolve<VacantPositionModel | UrlTree> {
  private readonly vacantPositionService = inject(VacantPositionService);
  private readonly router = inject(Router);

  public resolve(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot): Observable<VacantPositionModel | UrlTree> {
    const nodeId = route.queryParams['nid'] as string | undefined;
    const positionTitle = route.paramMap.get('vacantPositionTitle');
    const lookupPath = nodeId ?? `/vacant-position/${positionTitle}`;

    return this.vacantPositionService.getVacantPosition(lookupPath).pipe(
      defaultIfEmpty(null),
      map((position) => position ?? this.router.createUrlTree(['/404'])),
      catchError((err) => {
        nrError(err, { context: 'vacant_position_resolver', nodeId, positionTitle });
        return of(this.router.createUrlTree(['/404']));
      })
    );
  }
}
